
export default {
  // Partners Page
  ourMediaPartner: "Our Media Partner",
  ourMediaPartners: "Our Media Partners", 
  collaborationText: "Collaboration",
  toProvideText: "To Provide",
  partnerDescription: "We collaborate with leading media partners to provide comprehensive advertising solutions",
  viewBusinessCases: "View Pitch Deck",
  viewMediaKit: "View Media Kit",
  readyToReach: "Ready to Reach Your Audience?",
  startYourDigital: "Start Your Digital Campaign Today",
  andReachYour: "And Reach Your Target Audience",
  createCampaign: "Create Campaign",
  learnMore: "Learn More",
  
  // Hero Section
  premiumMediaPartnerNetwork: "Premium Media Partner Network",
  
  // Stats Section
  ourNetworkImpact: "Our Network Impact",
  connectingBrands: "Connecting brands with audiences through our extensive partner network",
  mediaPartners: "Media Partners",
  digitalScreens: "Digital Screens",
  
  // Partners Section
  exploreOurPartners: "Explore Our Partners",
  explorePartnersDesc: "Choose from our indoor and outdoor advertising networks to reach your target audience",
  indoor: "Indoor",
  outdoor: "Outdoor",
  comingSoon: "Coming Soon",
  stayTuned: "Stay Tuned",
  
  // Benefits Section
  whyChoosePartners: "Why Choose Our Media Partners?",
  whyChoosePartnersDesc: "Unlock the power of strategic partnerships for maximum advertising impact",
  targetedAudience: "Targeted Audience",
  targetedAudienceDesc: "Reach your ideal customers where they spend their time with precision targeting.",
  performanceMetrics: "Performance Metrics",
  performanceMetricsDesc: "Track impressions, engagement, and ROI with detailed analytics and reporting.",
  quickSetup: "Quick Setup",
  quickSetupDesc: "Launch campaigns quickly with our streamlined creation process and approval workflow.",
  
  // Partner Descriptions
  tableadsDesc: "Reach your audience where they eat, drink, and unwind — with TableAds' digital advertising in cafés, restaurants, and lounges.",
  alanDesc: "Advertise where people move, meet, and play — fitness centers, cafés, lounges, and game zones, all powered by Alan.",
  wakiDesc: "Connect with the next generation — digital advertising in Private and International schools with Waki.",
  attentionDesc: "The purpose of Attention is to run a world-class professional OUTDOOR MEDIA. The objective is to be exceptional by world standards, not just GCC or Saudi standards.",
  comingSoonDesc: "Exciting new outdoor media partnerships are on the horizon. Stay tuned for innovative advertising solutions that will expand your reach.",
  elevateMediaDesc: "Captivate audiences at every floor — Elevate Media delivers premium elevator advertising solutions in residential and commercial buildings.",
  onspotDesc: "Engage your audience in the chair — On Spot delivers digital advertising in barber shops and beauty salons across the Kingdom.",
  
  // Partner Detail Page
  partnerDetailsComingSoon: "Partner details coming soon",
  workingOnAddingInfo: "We're working on adding more information about this partner.",
  backToPartners: "Back to Partners",
} as const;
